import React, {Component} from "react";
import {Link, withRouter} from "react-router-dom";
import {Nav, Navbar, NavItem, Row, Col} from "react-bootstrap";
import FontAwesome from './components/FontAwesome';
import {authUser, signOutUser} from "./libs/awsLib";
import RouteNavItem from "./components/RouteNavItem";
import Routes from "./Routes";
import "./App.css";

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            keys: '',
            showMenu: false,
            isAuthenticated: false,
            isAuthenticating: true
        };
    }

    async componentDidMount() {
        if (this.isFrontpage()) {
            document.addEventListener('keydown', this.keyPressed, false);
        }
        try {
            if (await authUser()) {
                this.userHasAuthenticated(true);
            }
        }
        catch (e) {
            alert(e);
        }

        this.setState({isAuthenticating: false});
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.keyPressed, false);
    }

    isFrontpage() {
        const location = this.props.location;
        return location && location.pathname && location.pathname.length === 1;
    }

    isInternPages() {
        const location = this.props.location;
        return location && location.pathname && location.pathname.indexOf('intern') >= 0;
    }

    isRedirectPages() {
        const location = this.props.location;
        return location && location.pathname && location.pathname.indexOf('redirect') >= 0;
    }

    isBarelPages() {
        const location = this.props.location;
        return location && location.pathname && location.pathname.indexOf('barel') >= 0;
    }

    isJaktaTivoliPages() {
        const location = this.props.location;
        return location && location.pathname && location.pathname.indexOf('jakta-tivoli') >= 0;
    }

    userHasAuthenticated = authenticated => {
        this.setState({isAuthenticated: authenticated});
    };

    handleLogout = event => {
        signOutUser();

        this.userHasAuthenticated(false);

        this.props.history.push("/");
    };

    keyPressed = (event) => {
        let keys = this.state.keys;
        keys += event.key;
        this.setState({
            keys: keys,
            showMenu: keys.indexOf('danger') >= 0
        }, () => {
            if (keys.indexOf('intern') >= 0) {
                event.preventDefault();
                this.props.history.push("/intern");
                document.removeEventListener('keydown', this.keyPressed, false);
                this.setState({
                    keys: '',
                    showIntern: keys.indexOf('intern') >= 0
                });
            }
        });
    };

    menu(name, url) {
        return (
            <RouteNavItem href={url} key={'menu-' + name}>
                <FontAwesome name={name} size={'2x'} red/>
            </RouteNavItem>
        );
    }

    renderGamnesMenu() {
        let menus = [
            this.menu('industry', '/selskapet')
        ];
        if (this.state.showMenu) {
            menus.push(this.menu('briefcase', '/prosjekter'));
            menus.push(this.menu('graduation-cap', '/cv'));
        }
        return (
            <Navbar fluid collapseOnSelect>
                <Navbar.Header>
                    <Navbar.Brand>
                        <Link to="/">
                            <FontAwesome name="home" size={'2x'} red/>
                        </Link>
                    </Navbar.Brand>
                    <Navbar.Toggle/>
                </Navbar.Header>
                <Navbar.Collapse>
                    <Nav pullRight>
                        {menus}
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        );
    }

    renderInternMenu() {
        const logout = <NavItem onClick={this.handleLogout}><FontAwesome name={'sign-out'} size={'2x'} red/></NavItem>;
        return (
            <Navbar fluid collapseOnSelect>
                <Navbar.Header>
                    <Navbar.Brand>
                        <Link to="/intern">
                            <FontAwesome name="hand-spock" size={'2x'} red/>
                        </Link>
                    </Navbar.Brand>
                    <Navbar.Toggle/>
                </Navbar.Header>
                <Navbar.Collapse>
                    <Nav pullRight>
                        {this.state.isAuthenticated ? logout : null}
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        );
    }

    renderMenu() {
        if (this.isInternPages()) {
            return this.renderInternMenu();
        }
        if (this.isRedirectPages()) {
            return null;
        }
        return this.renderGamnesMenu();
    }

    renderFooter() {
        return (
            <Row className="show-grid row text-center">
                <Col xs={12} md={12}>
                    <span>Gamnes & Bror</span>
                </Col>
            </Row>
        )
    }

    render() {
        const childProps = {
            isAuthenticated: this.state.isAuthenticated,
            userHasAuthenticated: this.userHasAuthenticated
        };
        if (this.isBarelPages() || this.isJaktaTivoliPages()) {
            return (
                <div>
                    <Routes childProps={childProps}/>
                </div>
            );
        }
        return (
            <div className="App container">
                {this.renderMenu()}
                <Routes childProps={childProps}/>
            </div>
        );
    }
}

export default withRouter(App);


// WEBPACK FOOTER //
// ./src/AppWithMenu.js